var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgConquests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1206 40.3345H47.8808V72.5709H32.1206V40.3345Z",
    fill: "#FFD60D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0681 40.3333H47.8819V72.5696H40.0681V40.3333Z",
    fill: "#FFB92C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6931 76.2779L47.8801 65.5293H32.1198L24.3068 76.2779C23.7885 76.9909 23.7142 77.9343 24.1143 78.7198C24.5145 79.5051 25.3213 79.9996 26.2027 79.9996H53.7971C54.6785 79.9996 55.4854 79.5051 55.8856 78.7198C56.2857 77.9343 56.2112 76.9909 55.6931 76.2779Z",
    fill: "#FFB92C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4062 0H8.59375C7.29937 0 6.25 1.04937 6.25 2.34375V21.6258C6.25 22.6417 6.90438 23.5419 7.87094 23.8553L18.107 27.1744C19.267 38.2297 28.6425 46.875 40 46.875C51.3575 46.875 60.733 38.2295 61.893 27.1742L72.1291 23.8552C73.0955 23.5419 73.75 22.6416 73.75 21.6256V2.34375C73.75 1.04937 72.7006 0 71.4062 0V0ZM10.9375 4.6875H17.9856V22.2072L10.9375 19.9219V4.6875ZM69.0625 19.9219L62.0144 22.2073V4.6875H69.0625V19.9219Z",
    fill: "#FFB92C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.408 0H40.0681V46.8742C51.3956 46.8405 60.737 38.208 61.8947 27.1742L72.1308 23.8552C73.0972 23.5419 73.7517 22.6416 73.7517 21.6256V2.34375C73.7517 1.04937 72.7023 0 71.408 0V0ZM69.0642 19.9219L62.0161 22.2073V4.6875H69.0642V19.9219Z",
    fill: "#FF9100"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.954 31.0314L33.8951 23.9292L38.0562 28.0903L30.954 31.0314ZM40.5338 29.7788L42.1697 25.8081L36.0821 19.728L32.1089 21.3764L29 18.265L47.9642 11L50.9704 14.0062L43.7179 32.9904L40.5338 29.7788Z",
    fill: "#F7E072"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8819 65.5293H40.0681V79.9996H53.7989C54.6803 79.9996 55.4872 79.5051 55.8873 78.7198C56.2875 77.9343 56.2129 76.9909 55.6948 76.2779L47.8819 65.5293Z",
    fill: "#FF9100"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConquests);
export default __webpack_public_path__ + "static/media/conquests.df5f533068fba3feb5566c542515bcc2.svg";
export { ForwardRef as ReactComponent };